import React from 'react';
import ISO6391 from 'iso-639-1';

import {
	Modal, Select, Option, Button,
} from '@sololearnorg/sol';

import { SlLEContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { TranslationIcon } from './TranslationIcon';
import { SlDataService } from '../../services/sl-data.service';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { Container, i18n } from '../../../../symphony';

interface ICourseTranslationModalProps {
	selectedLocal: string;
	setSelectedLocal: React.Dispatch<React.SetStateAction<string>>;
	updateLastTranslatedLanguage: (language: string) => void;
	defaultLanguage: string;
	courseLanguage: string;
}

export const CourseTranslationModal = ({
	selectedLocal,
	setSelectedLocal,
	updateLastTranslatedLanguage,
	defaultLanguage,
	courseLanguage,
}: ICourseTranslationModalProps) => {
	const { actions$ } = Container.take(SlLEContext, SlActions);
	const { course$: course } = useContainerData(SlLEContext, SlDataService, [
		'course$',
	]);

	const translateButtonClickHandler = () => {
		actions$.next({
			type: ActionType.OnTranslateButtonClick,
			requestType: RequestType.Parallel,
			data: {
				locale: selectedLocal,
			},
		});
		updateLastTranslatedLanguage(
			selectedLocal === defaultLanguage ? null : selectedLocal,
		);
	};

	const closeModalClickHandler = () => {
		actions$.next({
			type: ActionType.OnCloseTranslationModalClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<Modal.Custom
			onClose={closeModalClickHandler}
			dataTestid="cmpDownloadCertificate2"
			className="le-course-translation__modal"
		>
			<div className="le-course-translation__modal__icon">
				<TranslationIcon />
			</div>
			<div className="le-course-translation__modal__title">
				{i18n.t('web-le.translate-course-modal-title')}
			</div>
			<div className="le-course-translation__modal__description">
				{i18n.t('web-le.translate-course-modal-description')}
			</div>
			<Select
				defaultValue={courseLanguage}
				className="le-course-translation__modal__select"
				onValueChange={(value) => {
					setSelectedLocal(value);
				}}
			>
				{course?.supportedLocales?.map((supportedLocale) => (
					<Option
						value={supportedLocale.locale}
						key={supportedLocale.locale}
					>
						{ISO6391.getNativeName(
							supportedLocale.locale.toLowerCase(),
						)}
						{' '}
						{!supportedLocale.isVerified ? '*' : ''}
					</Option>
				))}
			</Select>
			<Button
				onClick={translateButtonClickHandler}
				disabled={!selectedLocal || selectedLocal === courseLanguage}
			>
				{i18n.t('web-le.translate-course-modal-translate-button')}
			</Button>
			{course?.supportedLocales?.find((locale) => !locale.isVerified) && (
				<div className="le-course-translation__modal__note">
					{i18n.t('web-le.translate-course-modal-note')}
				</div>
			)}
		</Modal.Custom>
	);
};
